export const DEFAULT_QUOTATION_EXCLUSION_OPTIONS = [
  'Service Engineering (Fire, Hydraulics, Mechanical etc.)',
  'Post-tensioned concrete design',
  'Construction Engineering (e.g. formwork design and temporary works)',
  'Fee to search relevant information for design. (e.g. SDO, Existing Structural Drawing etc.)',
  'Checking of steel shop drawings',
  'Stair / Fence / Balustrade / Pool Shell designs (unless otherwise stated)',
  'Site visits / Inspections (unless otherwise stated)',
  'Authority fees',
  'Construction meeting if required (Rate outlined below)',
  'Additional work or changes that require significant re-design (Rate outlined below)',
  'Any work carried out if the project does not proceed, this includes site visits, meeting (Rate outlined below)',
  'Dual Structural Certificate by another engineer if required by the building surveyor',
  'As-built drawings or as-built certificate of compliance',
  'Certification of constructional material',
  'Flood / Hydraulic modelling / analysis (e.g. MUSIC analysis)',
  'Roof/building to downpipe design and suspended building drainage design',
  'Rainwater Tank Design and Documentation',
  'Demolition Plan / Design',
  'Roof truss design and certification',
  'Fire Engineering and fire rating system design and certification.',
  'Underpin Design / Performance Solutions',
  'Outfall drainage design and documentation as required by service authority.',
] as const;

export function normalizeQuotationExclusionLabel(value: unknown): string {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

export function isCivilQuotationExclusion(label: string): boolean {
  return /\b(civil|flood|hydraulic modelling|music analysis|drainage|downpipe|rainwater|wsud|outfall|bitumen|pavement)\b/i.test(
    normalizeQuotationExclusionLabel(label),
  );
}

export function dedupeQuotationExclusions(values: Iterable<unknown>): string[] {
  const seen = new Set<string>();
  const output: string[] = [];

  for (const value of values) {
    const normalized = normalizeQuotationExclusionLabel(value);
    const key = normalized.toLowerCase();
    if (!normalized || seen.has(key)) {
      continue;
    }
    seen.add(key);
    output.push(normalized);
  }

  return output;
}

export function orderQuotationExclusions(labels: string[], preferredOrder: string[] = []): string[] {
  const available = new Map(dedupeQuotationExclusions(labels).map((label) => [label.toLowerCase(), label]));
  const ordered = dedupeQuotationExclusions([...preferredOrder, ...labels])
    .map((label) => available.get(label.toLowerCase()))
    .filter((label): label is string => Boolean(label));
  return preferredOrder.length > 0
    ? ordered
    : [false, true].flatMap((civil) => ordered.filter((label) => isCivilQuotationExclusion(label) === civil));
}

export function moveQuotationExclusion(labels: string[], from: string, to: string, withinGroup = true): string[] {
  const source = labels.findIndex((label) => label.toLowerCase() === from.toLowerCase());
  const target = labels.findIndex((label) => label.toLowerCase() === to.toLowerCase());
  if (source < 0 || target < 0 || source === target
    || (withinGroup && isCivilQuotationExclusion(labels[source]) !== isCivilQuotationExclusion(labels[target]))) return labels;
  const next = [...labels];
  next.splice(target, 0, next.splice(source, 1)[0]);
  return next;
}
